var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocBackGlare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 51,
    viewBox: "0 0 81 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_151_241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.0002 4.61035V46.4381C81.0002 47.648 80.5536 48.8084 79.7585 49.664C78.9635 50.5195 77.8852 51.0002 76.7608 51.0002H4.56165C3.4373 51.0002 2.359 50.5195 1.56395 49.664C0.768906 48.8084 0.322266 47.648 0.322266 46.4381V4.61035H81.0002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0002 2.52842V4.61017H0.322266V2.52842C0.322266 1.85784 0.768906 1.21473 1.56396 0.74056C2.359 0.26639 3.43729 0 4.56165 0H76.7608C77.8852 0 78.9635 0.26639 79.7585 0.74056C80.5536 1.21473 81.0002 1.85784 81.0002 2.52842Z",
    fill: "#6B22B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.49849 3.24134e-08H77.2126C78.2163 0.000710032 79.1788 0.33218 79.8888 0.92171C80.5988 1.51124 80.9984 2.3107 81 3.14473L80.9851 3.74576C80.9851 2.00945 79.2713 0.59936 77.1648 0.59936H3.80169C2.96035 0.59891 2.14235 0.82919 1.47461 1.25449C1.82704 0.86486 2.28371 0.54869 2.80852 0.33096C3.33334 0.11324 3.91191 -6.99676e-05 4.49849 3.24134e-08Z",
    fill: "#C35CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7119 36.5933H72.356V38.3221H29.7119V36.5933Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9492 11.2373H72.356V12.9661H23.9492V11.2373Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2036 16.7119H72.3562V18.4407H37.2036V16.7119Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2544 21.8984H72.3561V23.6273H26.2544V21.8984Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3999 21.7949H23.673V23.5237H5.3999V21.7949Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.6611 26.7969H72.3561V28.5257H57.6611V26.7969Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6099 26.7969H53.6269V28.5257H34.6099V26.7969Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5083 26.7969H30.8643V28.5257H5.5083V26.7969Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5083 41.4917H30.8643V43.2205H5.5083V41.4917Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8813 41.4917H58.2372V43.2205H32.8813V41.4917Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9663 41.4917H72.3562V43.2205H59.9663V41.4917Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 36.5933H25.3898V38.3221H13V36.5933Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3999 16.8398H28.7087V18.5687H5.3999V16.8398Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5083 31.6948H72.3558V33.4236H5.5083V31.6948Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.18164 11.2104H20.2793V12.9394H8.18164V11.2104Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.78,
    filter: "url(#filter0_f_151_241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.3223 33C72.0543 33 78.3223 26.732 78.3223 19C78.3223 11.268 72.0543 5 64.3223 5C56.5903 5 50.3223 11.268 50.3223 19C50.3223 26.732 56.5903 33 64.3223 33Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter1_f_151_241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3223 42C29.0543 42 35.3223 35.732 35.3223 28C35.3223 20.268 29.0543 14 21.3223 14C13.5903 14 7.32227 20.268 7.32227 28C7.32227 35.732 13.5903 42 21.3223 42Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.78,
    filter: "url(#filter2_f_151_241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.3223 49C66.0543 49 72.3223 42.732 72.3223 35C72.3223 27.268 66.0543 21 58.3223 21C50.5903 21 44.3223 27.268 44.3223 35C44.3223 42.732 50.5903 49 58.3223 49Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_151_241",
    x: 41.3223,
    y: -4,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    result: "effect1_foregroundBlur_151_241"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_151_241",
    x: -1.67773,
    y: 5,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    result: "effect1_foregroundBlur_151_241"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_151_241",
    x: 35.3223,
    y: 12,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    result: "effect1_foregroundBlur_151_241"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_151_241"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 51,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocBackGlare);
export default __webpack_public_path__ + "static/media/doc-back-glare.661d87579191a25be7924371aac537b9.svg";
export { ForwardRef as ReactComponent };